import {
    GraduationCap,
    Compass,
    Wrench,
    UserCheck,
    Users,
    BookOpen,
    Bell,
    Library,
    Sparkles,
} from "lucide-react";

export const ASSETS = {
    logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_4e9fe525-66e2-43c9-9e5c-c8a50345aba2/artifacts/e5048ae46a35eef0_ISelfLawAmMaster%20LOGO%20Final.png",
    banner: "/assets/hero-banner.webp",
    monogram: "/assets/bt-monogram-navy.webp",
    monogramWhite: "/assets/bt-monogram-white.webp",
    monogramQuill: "/assets/bt-monogram-quill.webp",
    portrait: "/assets/brothatruth-portrait.webp",
};

export const NAV_LINKS = [
    { label: "Home", id: "hero", testId: "nav-link-home" },
    { label: "Our Services", id: "services", testId: "nav-link-services" },
    { label: "Products", id: "products", testId: "nav-link-products" },
    { label: "Education", id: "why-choose", testId: "nav-link-education" },
    { label: "Resources", id: "community", testId: "nav-link-resources" },
    { label: "About", id: "about", testId: "nav-link-about" },
    { label: "Contact", id: "footer", testId: "nav-link-contact" },
];

export const SERVICES = [
    {
        key: "genealogy",
        title: "Genealogy Services",
        badge: "Heritage & Ancestry",
        accent: "#1E5A38",
        accentDeep: "#153B25",
        ctaTextDark: false,
        headline: "Know Your History. Discover Your Lineage. Preserve Your Legacy.",
        description:
            "Explore your ancestral connections and uncover your family's history with professional genealogy research services.",
        cta: "Explore Genealogy",
        url: "https://iselflawammaster.com/lead-page/",
        image: "/assets/svc-genealogy.webp",
        alt: "Majestic ancestral tree with deep roots under golden sunlight",
    },
    {
        key: "equity-masterclass",
        title: "The Freedom Masterclass",
        badge: "Legal Education",
        accent: "#D9A441",
        accentDeep: "#9E6D18",
        ctaTextDark: true,
        headline: "Don't Just Know Your Rights. Learn the Principles Behind Them.",
        description:
            "Designed for those ready to discharge their debts — gain a deeper understanding of Equity Jurisprudence, Common Law, trusts, and equitable remedies.",
        cta: "Join The Masterclass",
        url: "https://www.skool.com/iselflawammasteronline",
        image: "/assets/svc-equity.webp",
        alt: "Golden scales of justice with historical legal books",
    },
    {
        key: "theequalizer-ai",
        title: "TheEqualizer.AI",
        badge: "AI Equity Tool",
        accent: "#2A5CDB",
        accentDeep: "#123EA8",
        ctaTextDark: false,
        headline: "Technology Meets Knowledge. Information Meets Action.",
        description:
            "Your AI-powered tool to help you enforce your rights, organize information, and explore possible remedies.",
        cta: "Explore The AI Platform",
        url: "https://theequalizer.ai",
        image: "/assets/svc-ai.webp",
        alt: "Futuristic AI interface with digital intelligence visuals",
    },
    {
        key: "we-do-it-for-you",
        title: "We Do It For You Services",
        badge: "Done-For-You",
        accent: "#8B2BE2",
        accentDeep: "#7200C8",
        ctaTextDark: false,
        headline: "Need Assistance? Let Our Team Help.",
        description:
            "Personalized document preparation and administrative support services designed to save you time and provide peace of mind.",
        cta: "View Our Services",
        url: "https://iselflawammaster.com/we-do-it-for-you-services/",
        image: "/assets/svc-wdify.webp",
        alt: "Premium documents organized with a gold fountain pen",
    },
    {
        key: "status-correction",
        title: "Status Correction Curriculums",
        badge: "Structured Education",
        accent: "#A01236",
        accentDeep: "#850C28",
        ctaTextDark: false,
        headline: "From Beginner to Advanced.",
        description:
            "Choose between our Newbie or Full-Time Curriculums and build a strong foundation through structured education.",
        cta: "Explore Curriculums",
        url: "https://iselflawammaster.com/signup",
        image: "/assets/svc-status.webp",
        alt: "Graduation cap resting on academic books",
    },
    {
        key: "consumer-repair",
        title: "Consumer Repair Services",
        badge: "Consumer Profile",
        accent: "#0A7A86",
        accentDeep: "#00565F",
        ctaTextDark: false,
        headline: "Reclaim Control of Your Consumer Profile.",
        description:
            "Get assistance with consumer report reviews, disputes, and education to help you address inaccurate, incomplete, or questionable information.",
        cta: "Access Consumer Services",
        url: "https://app.iselflawammaster.com",
        image: "/assets/svc-consumer.webp",
        alt: "Digital consumer report interface with a protective shield",
    },
];

export const PRODUCTS = [
    {
        key: "copper-mug",
        name: "Premium 16 Oz Copper Mug",
        tagline: "Handcrafted · 100% Pure Copper",
        price: "$25.00",
        wasPrice: "$35.00",
        badge: "Signature Product",
        description:
            "Handcrafted from 100% pure copper with a polished, food-safe finish. Keeps drinks icy longer — and copper naturally neutralizes bacteria on contact.",
        cta: "Get The Copper Mug",
        url: "https://iselflawammaster.com/product/premium-16-oz-copper-mug-handcrafted-100-pure-copper/",
        image: "/assets/product-copper-mug.webp",
        alt: "Premium 16 oz handcrafted 100% pure copper mug",
    },
    {
        key: "geneva-bible",
        name: "Geneva Bible: The Holy Grail Edition",
        tagline: "Digital & Hard Copy",
        price: "$35.00 – $65.00",
        wasPrice: null,
        badge: "Signature Product",
        description:
            "The Geneva Bible presented like never before — including the Apocrypha, the Book of Enoch, the Book of Giants, and the Gnostic Gospels.",
        cta: "Get The Holy Grail Edition",
        url: "https://iselflawammaster.com/product/geneva-bible-the-holy-grail-edition/",
        image: "/assets/product-geneva-bible.webp",
        alt: "Geneva Bible — The Holy Grail Edition book",
    },
    {
        key: "sovereign-chronicles",
        name: "Sovereign Chronicles",
        tagline: "The Complete Book Collection",
        price: "On Amazon",
        wasPrice: null,
        badge: "Book Collection",
        description:
            "The complete Sovereign Chronicles series — volumes on status transformation, sacred writs, taxation, courts, and the path to sovereignty.",
        cta: "View On Amazon",
        url: "https://www.amazon.com/dp/B0F9LBSTR7?binding=paperback&searchxofy=true&ref_=dbs_s_aps_series_rwt_tpbk&qid=1753512841&sr=8-1",
        image: "/assets/product-sovereign-chronicles.webp",
        alt: "Sovereign Chronicles complete book collection lineup",
        contain: true,
    },
];

export const BENEFITS = [
    {
        icon: GraduationCap,
        title: "Education",
        description: "Learn the principles that create understanding.",
    },
    {
        icon: Compass,
        title: "Expert Guidance",
        description: "Gain access to tools and services designed for real-world use.",
    },
    {
        icon: Wrench,
        title: "Practical Tools",
        description: "Technology and resources to help you take action.",
    },
    {
        icon: UserCheck,
        title: "Personal Support",
        description: "From self-education to done-for-you services.",
    },
    {
        icon: Users,
        title: "A Growing Community",
        description: "Join others committed to knowledge, empowerment, and legacy.",
    },
];

export const MARQUEE_ITEMS = [
    "Knowledge Is Power",
    "Understand Your Rights",
    "Establish Your Legacy",
    "The Pen Is Mightier Than The Sword",
    "Educate. Empower.",
    "Protect Your Interests",
];

export const COMMUNITY_BENEFITS = [
    { icon: BookOpen, label: "Educational Insights" },
    { icon: Bell, label: "Important Announcements" },
    { icon: Library, label: "New Resources & Courses" },
    { icon: Sparkles, label: "Exclusive Opportunities" },
];

export const MISSION_STATEMENT =
    "BrothaTruth's mission is to educate, empower, and inspire individuals and communities by making knowledge, resources, and opportunities more accessible. Through education, technology, culture, faith, and entrepreneurship, BrothaTruth seeks to equip people to make informed decisions, discover their potential, and build a lasting legacy for generations to come.";

export const LEGAL_DOCS = {
    privacy: {
        title: "Privacy Policy",
        body: [
            "ISelfLawAmMaster respects your privacy. When you join our community mailing list, we collect only your email address, and we use it solely to send you educational insights, announcements, new resources, and exclusive opportunities you asked to receive.",
            "We do not sell, rent, or share your personal information with third parties for their marketing purposes. Subscriber information is stored securely and access is limited to authorized team members.",
            "You may request removal from our mailing list at any time by contacting us through our website, and we will promptly delete your subscription record.",
            "This site may use privacy-respecting analytics to understand how visitors use the page so we can improve the experience. By using this website, you acknowledge this policy.",
        ],
    },
    terms: {
        title: "Terms & Conditions",
        body: [
            "By accessing this website, you agree to use its content for personal, educational purposes only. All materials, including text, graphics, logos, and images, are the property of ISelfLawAmMaster and may not be reproduced without written permission.",
            "The content provided on this website and through our services is for educational and informational purposes. It is not legal advice, and no attorney-client relationship is created by using this website or our services.",
            "Links to external platforms, including TheEqualizer.AI, Skool, and our service portals, are provided for convenience. Their own terms and policies apply when you use them.",
            "We may update these terms from time to time. Continued use of the website after changes are posted constitutes acceptance of the updated terms.",
        ],
    },
    disclaimer: {
        title: "Educational Disclaimer",
        body: [
            "ISelfLawAmMaster provides education, tools, and administrative support services. Nothing on this website constitutes legal advice, financial advice, or a guarantee of any outcome.",
            "We do not promise or guarantee specific legal outcomes, credit repair results, or changes in legal status. Results depend on individual circumstances and your own application of the material.",
            "Our curriculums, masterclasses, and AI tools are designed to help you learn, organize information, and make informed decisions. For matters requiring licensed legal counsel, you should consult a qualified attorney.",
            "By using this website, you acknowledge that you are responsible for your own decisions and actions.",
        ],
    },
};
